import axios from "axios";
import { Axios } from "./axios";
import {
  HCCCD_API,
  CLT_DANH_MUC_CO_QUAN_IGATE,
  CLT_DANH_MUC_CO_QUAN_IGATE_CAP_CCCD,
  CLT_DANH_MUC_QUOC_GIA_IGATE,
  CLT_DANH_MUC_TINH_IGATE,
  CLT_DANH_MUC_XA_PHUONG_IGATE,
  CLT_CAP_CN_ATTP_CONG_THUONG,
  CLT_CAP_CN_ATTP_KINH_DOANH_YT,
  HCCCD_API_N8N,
  CLT_DANH_MUC_TTHC,
  CLT_DANH_MUC_CO_QUAN_XU_LY_TTHC,
  CLT_DANH_MUC_FILE_MAU_IGATE,
  CLT_DANH_MUC_DONVI_HANHCHINH_CAP1,
  CLT_DANH_MUC_DONVI_HANHCHINH_CAP3,
} from "../api";

function getDanhMucCoQuan() {
  return Axios(
    "get",
    `${HCCCD_API}/ms/restheart/DB_HCCCD_DANH_MUC${CLT_DANH_MUC_CO_QUAN_IGATE}`
  );
}

function getDanhMucCoQuanCapCccd() {
  return Axios(
    "get",
    `${HCCCD_API}/ms/restheart/DB_HCCCD_DANH_MUC${CLT_DANH_MUC_CO_QUAN_IGATE_CAP_CCCD}`
  );
}

function getDanhMucQuocGia() {
  return Axios(
    "get",
    `${HCCCD_API}/ms/restheart/DB_HCCCD_DANH_MUC${CLT_DANH_MUC_QUOC_GIA_IGATE}`
  );
}

function getDanhMucTinh() {
  return Axios(
    "get",
    `${HCCCD_API}/ms/restheart/DB_HCCCD_DANH_MUC${CLT_DANH_MUC_TINH_IGATE}`
  );
}

function getDanhMucXaPhuong(parentId) {
  const filter = encodeURIComponent(JSON.stringify({ "parent.id": parentId }));
  return Axios(
    "get",
    `${HCCCD_API}/ms/restheart/DB_HCCCD_DANH_MUC${CLT_DANH_MUC_XA_PHUONG_IGATE}?filter=${filter}`
  );
}

function getDanhMucEform(id) {
  return Axios("get", `${HCCCD_API}/api/igate/eform/form/${id}`);
}

function getDanhSachQuyTrinhIgatle(id) {
  return Axios(
    "get",
    `${HCCCD_API}/api/igate/bd/procedure-process-definition?spec=page&page=0&size=50&status=1&procedure-id=${id}&disable-online=true`
  );
}

function getDanhSachGiayTo(id) {
  return Axios(
    "get",
    `${HCCCD_API}/api/igate/bd/procedure-form/?page=0&size=100&spec=page&procedure-id=${id}&default-online=1&status=1`
  );
}

function getDanhSachHinhThucNhanKetQua(id) {
  return Axios(
    "get",
    `${HCCCD_API}/api/igate/bt/tag/--by-category-id?status=1&category-id=${id}&page=0&size=50&sort=order,asc`
  );
}

function uploadFileIgate(fileOrFiles) {
  const formData = new FormData();

  if (Array.isArray(fileOrFiles)) {
    fileOrFiles.forEach((file) => {
      formData.append("files", file);
    });
  } else {
    formData.append("files", fileOrFiles);
  }

  return Axios("post", `${HCCCD_API}/api/igate/upload`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

function getHoSoAttpCongThuong(id) {
  return Axios(
    "get",
    `${HCCCD_API}/ms/restheart/DB_HCCCD${CLT_CAP_CN_ATTP_CONG_THUONG}/${id}`
  );
}

function getHoSoTTHC(collection, id) {
  return Axios("get", `${HCCCD_API}/ms/restheart/DB_HCCCD/${collection}/${id}`);
}

function getApplicantNyc(hosoId) {
  return Axios("get", `${HCCCD_API}/api/igate/applicant-nyc/${hosoId}`);
}

function getIgateDossierCode(hosoId) {
  return Axios("get", `${HCCCD_API}/api/igate/dossier-code/${hosoId}`);
}

function updateApplicantNyc(hosoId, data) {
  return Axios("patch", `${HCCCD_API}/api/igate/applicant-nyc/${hosoId}`, data);
}

function getTechUserByIdentityNumber(identityNumber) {
  const query = encodeURIComponent(identityNumber || "");
  return Axios("get", `${HCCCD_API}/api/igate/tech-user?identityNumber=${query}`);
}

function getHoSoAttpKinhDoanhYT(id) {
  return Axios(
    "get",
    `${HCCCD_API}/ms/restheart/DB_HCCCD${CLT_CAP_CN_ATTP_KINH_DOANH_YT}/${id}`
  );
}

function updateById(collection, id, data) {
  return Axios(
    "patch",
    `${HCCCD_API}/ms/restheart/DB_HCCCD/${collection}/${id}`,
    data
  );
}

function updateByIdKinhDoanhYT(id, data) {
  return Axios(
    "patch",
    `${HCCCD_API}/ms/restheart/DB_HCCCD${CLT_CAP_CN_ATTP_KINH_DOANH_YT}/${id}`,
    data
  );
}

function SubmitHoSoAttp(data) {
  return Axios("post", `${HCCCD_API_N8N}/api/gui-ho-so-1-cua`, data);
}

function getDanhMucTTHC(path) {
  return Axios(
    "get",
    `${HCCCD_API}/ms/restheart/DB_HCCCD_DANH_MUC${CLT_DANH_MUC_TTHC}?filter={"link":"${path}"}`
  );
}

function getCoQuanXuLyTTHC(MaTTHC) {
  return Axios(
    "get",
    `${HCCCD_API}/ms/restheart/DB_HCCCD_DANH_MUC${CLT_DANH_MUC_CO_QUAN_XU_LY_TTHC}?filter={"TTHC":"${MaTTHC}"}`
  );
}

function getDanhSachThuTucIgate(MaTTHC, idDonVi) {
  return Axios(
    "get",
    `${HCCCD_API}/api/igate/bd/procedure/--can-apply?page=0&spec=page&size=50&keyword=${MaTTHC}&agency-id=${idDonVi}`
  );
}

function getDanhMucFileMauIgate(MaTTHC) {
  return Axios(
    "get",
    `${HCCCD_API}/ms/restheart/DB_HCCCD_DANH_MUC${CLT_DANH_MUC_FILE_MAU_IGATE}?filter={"maThuTuc":"${MaTTHC}"}`
  );
}

const dowLoadFileKetQua = (id) => {
  return axios.get(
    `${HCCCD_API}/api/igate/ad/nps-dossier/63ad09eda913e3131eee3d98/downloadfile?fileid=${id}`,
    { responseType: "blob" }
  );
};

function getDanhMucTTHCByColection(Collection) {
  return Axios(
    "get",
    `${HCCCD_API}/ms/restheart/DB_HCCCD_DANH_MUC${CLT_DANH_MUC_TTHC}?filter={"Collection":"${Collection}"}`
  );
}

function getDanhMucByColection(Collection) {
  return Axios(
    "get",
    `${HCCCD_API}/ms/restheart/DB_HCCCD_DANH_MUC${Collection}`
  );
}

function getDanhMucDonViHanhChinhCap1(query) {
  return Axios(
    "get",
    `${HCCCD_API}/ms/restheart/DB_HCCCD_DANH_MUC${CLT_DANH_MUC_DONVI_HANHCHINH_CAP1}${query}`
  );
}

function getDanhMucDonViHanhChinhCap3(query) {
  return Axios(
    "get",
    `${HCCCD_API}/ms/restheart/DB_HCCCD_DANH_MUC${CLT_DANH_MUC_DONVI_HANHCHINH_CAP3}${query}`
  );
}

const getLogApiByHosoId = (id) => {
  const filter = JSON.stringify({
    url: { $regex: id },
    method: { $ne: "GET" },
  });
  return Axios(
    "get",
    `${HCCCD_API}/ms/restheart/DB_HCCCD_COMMON/cltLogApi?filter=${filter}&sort_by=-createdAt`
  );
};

export {
  getLogApiByHosoId,
  getDanhMucDonViHanhChinhCap1,
  getDanhMucDonViHanhChinhCap3,
  getDanhMucByColection,
  getDanhMucTTHCByColection,
  getDanhMucCoQuan,
  getDanhMucCoQuanCapCccd,
  getDanhMucQuocGia,
  getDanhMucTinh,
  getDanhMucXaPhuong,
  getDanhMucEform,
  getDanhSachGiayTo,
  getDanhSachQuyTrinhIgatle,
  uploadFileIgate,
  getDanhSachHinhThucNhanKetQua,
  getHoSoAttpCongThuong,
  updateById,
  getHoSoAttpKinhDoanhYT,
  updateByIdKinhDoanhYT,
  SubmitHoSoAttp,
  getDanhMucTTHC,
  getCoQuanXuLyTTHC,
  getDanhSachThuTucIgate,
  getHoSoTTHC,
  getApplicantNyc,
  getIgateDossierCode,
  updateApplicantNyc,
  getTechUserByIdentityNumber,
  getDanhMucFileMauIgate,
  dowLoadFileKetQua
};
